<template>
  <div class="personal-style-banner margin-bottom-m lh-container-custom-gutters">
    <div
      :class="[
        'small-padding-xs medium-padding-right-xl medium-padding-left-xl',
        'medium-padding-top-s medium-padding-bottom-s stylist-banner-container-width',
      ]"
    >
      <!-- banner-anchor-logo-section -->
      <div>
        <img
          :src="bannerAnchorLogo"
          alt="anchorlogo"
        />
      </div>
      <div class="margin-top-xs margin-bottom-xs">
        <h4 class="banner-text-color">
          {{ PERSONAL_STYLIST_BANNER.HEADER_TEXT }}
        </h4>
      </div>
      <div class="margin-bottom-m">
        <p class="body medium banner-text-color">
          {{ PERSONAL_STYLIST_BANNER.CONTENT_DESCRIPTION }}
        </p>
      </div>
      <div>
        <a
          :href="PERSONAL_STYLIST_BANNER.REDIRECTION_URL"
          class="primary button button-small"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ PERSONAL_STYLIST_BANNER.BOOK_NOW }}
        </a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { PERSONAL_STYLIST_BANNER } from '../../config';
import bannerAnchorLogo from '../../assets/images/anchor-logo.svg';
</script>
<style lang="scss" scoped>
.stylist-banner-container-width {
  max-width: 70%;
}
.banner-text-color {
  color: $white;
}
.personal-style-banner {
  @media screen and (min-width: 80em) {
    background: url('../../assets/images/stylistBanner/stylist_large_desktop.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media screen and (min-width: 1025px) and (max-width: 1440px) {
    background: url('../../assets/images/stylistBanner/stylist_small_desktop.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    background: url('../../assets/images/stylistBanner/stylist_tablet.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media screen and (max-width: 601px) {
    background: url('../../assets/images/stylistBanner/stylist_mobile.png');
    background-repeat: no-repeat;
    background-size: cover;
    .stylist-banner-container-width {
      max-width: 94%;
    }
  }
}
.lh-container-custom-gutters:deep() {
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
  @include breakpoint(small down) {
    margin-right: rem-calc(0);
    margin-left: rem-calc(0);
  }
}
</style>
